/**
 * @generated SignedSource<<3feed4928d34ded3e42fa7ffa97bea92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type accountCreateStripeConnectAccountLinkMutation$variables = {};
export type accountCreateStripeConnectAccountLinkMutation$data = {
  readonly createStripeConnectAccountLink: string | null;
};
export type accountCreateStripeConnectAccountLinkMutation = {
  variables: accountCreateStripeConnectAccountLinkMutation$variables;
  response: accountCreateStripeConnectAccountLinkMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createStripeConnectAccountLink",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "accountCreateStripeConnectAccountLinkMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "accountCreateStripeConnectAccountLinkMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "db1b5082067192faa0bd67ce15b53a36",
    "id": null,
    "metadata": {},
    "name": "accountCreateStripeConnectAccountLinkMutation",
    "operationKind": "mutation",
    "text": "mutation accountCreateStripeConnectAccountLinkMutation {\n  createStripeConnectAccountLink\n}\n"
  }
};
})();

(node as any).hash = "03cd2317d52675e2ee35084fece132ea";

export default node;
